@if (canShowCta) {
  @if (canShowWebcomponent) {
    <luigi-container
      class="m-auto"
      [viewurl]="url"
      [id]="luigiHtmlId"
      webcomponent='{ "selfRegistered": true }'
      [context]="btnContext()"
      [dcpShowFormButton]="{name: formDataTrackingService.generateFormName(
          transactionType.adobeFormType,
          product
        ),
        product: product,
        productId: dcpProductUtilitiesService.getProductId(product),
        actionType: transactionType?.actionType
      }"
    ></luigi-container>
  } @else {
    <udex-button
      (click)="executeAction(product, slmTransactionType)"
      [attr.data-cy]="slmTransactionType.code"
      [class.btn-outline-primary]="outlineButtons && !highlightFirstButton"
      [class.btn-primary]="highlightFirstButton || !outlineButtons"
      [class.btn-sm]="smallButtons"
      [class.flex-grow-1]="fullWidth"
      [class.m-0]="disableMargin"
      [dcpShowFormButton]="{name: formDataTrackingService.generateFormName(
          transactionType.adobeFormType,
          product
        ),
        product: product,
        actionType: transactionType?.actionType
      }"
      [disabled]="isDisabled"
      class="btn lead-btn d-flex justify-content-center"
    >
      {{slmTransactionType?.name?.length ? slmTransactionType?.name : (transactionType.ctaLabel | cxTranslate)}}
    </udex-button>
  }

} @else {
  <button
    (click)="openSupportForm()"
    type="button"
    class="btn btn-primary m-auto"
  >
    {{(slmTransactionType.label | cxTranslate) || ('productDetails.contactSupport' | cxTranslate)}}
  </button>
}
